import {atom} from "recoil";
import {User} from "firebase/auth";

export const AuthState = atom<User | null>({
    key: 'authState',
    default: null,
    dangerouslyAllowMutability: true
});

